import { render, staticRenderFns } from "./ComponentGap.vue?vue&type=template&id=b1502416&scoped=true"
import script from "./ComponentGap.vue?vue&type=script&lang=js"
export * from "./ComponentGap.vue?vue&type=script&lang=js"
import style0 from "./ComponentGap.vue?vue&type=style&index=0&id=b1502416&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1502416",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1502416')) {
      api.createRecord('b1502416', component.options)
    } else {
      api.reload('b1502416', component.options)
    }
    module.hot.accept("./ComponentGap.vue?vue&type=template&id=b1502416&scoped=true", function () {
      api.rerender('b1502416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/panelStyle/ComponentGap.vue"
export default component.exports